import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopHeader = _resolveComponent("TopHeader")!
  const _component_NavbarTwo = _resolveComponent("NavbarTwo")!
  const _component_MainBanner = _resolveComponent("MainBanner")!
  const _component_PartnerWrapper = _resolveComponent("PartnerWrapper")!
  const _component_WhatWeDo = _resolveComponent("WhatWeDo")!
  const _component_AwardWinningAgency = _resolveComponent("AwardWinningAgency")!
  const _component_IncreaseYourBrands = _resolveComponent("IncreaseYourBrands")!
  const _component_CapabilitiesContent = _resolveComponent("CapabilitiesContent")!
  const _component_OurProcess = _resolveComponent("OurProcess")!
  const _component_SuccessStories = _resolveComponent("SuccessStories")!
  const _component_TestimonialsContent = _resolveComponent("TestimonialsContent")!
  const _component_OurExperts = _resolveComponent("OurExperts")!
  const _component_OurBlog = _resolveComponent("OurBlog")!
  const _component_HarnessPowerOfSocialMedia = _resolveComponent("HarnessPowerOfSocialMedia")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TopHeader),
    _createVNode(_component_NavbarTwo),
    _createVNode(_component_MainBanner),
    _createVNode(_component_PartnerWrapper),
    _createVNode(_component_WhatWeDo),
    _createVNode(_component_AwardWinningAgency),
    _createVNode(_component_IncreaseYourBrands, { class: "bg-color-f2f2f8" }),
    _createVNode(_component_CapabilitiesContent),
    _createVNode(_component_OurProcess),
    _createVNode(_component_SuccessStories),
    _createVNode(_component_TestimonialsContent),
    _createVNode(_component_OurExperts),
    _createVNode(_component_OurBlog, { class: "pt-100" }),
    _createVNode(_component_HarnessPowerOfSocialMedia),
    _createVNode(_component_MainFooter, { class: "bg-style" })
  ], 64))
}